import apolloClient from '../../utils/apollo-client';
import { updateUserOrganisation as mutation } from '../../api/graphql/user';
import { getEnv } from 'ecx.saigon.ui.common';
import Mock from './mock';

export default async function updateUserOrganisation(orgId) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.updateUserOrganisation;
  }
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: { orgId }
    })
  );
  return response.data.updateUserOrganisation;
}
